module.exports = "<client-selector button-text=\"'View Report'\" client-list=$ctrl.clientList on-button-click=$ctrl.viewReport(clientList)> </client-selector> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/report-client-selector/report-client-selector.html
// module id = 358
// module chunks = 0